import { Form, FormInstance, Select } from 'antd';
import { NamePath } from 'antd/es/form/interface';
import { SubscriptionCycle } from '../../services/api/types/billing';
import React from 'react';

interface SubscriptionCycleSelectorProps {
  name?: NamePath;
  label?: string;
  defaultValue?: SubscriptionCycle;
  form?: FormInstance;
  required?: boolean;
  onChange?: (value: SubscriptionCycle) => void;
  value?: SubscriptionCycle;
  style?: React.CSSProperties;
  disabled?: boolean;
}

function SubscriptionCycleSelector({
  name,
  label = 'Select cycle',
  defaultValue,
  form,
  required = true,
  value,
  onChange,
  style,
  disabled = false,
}: SubscriptionCycleSelectorProps) {
  if (onChange) {
    return (
      <Form.Item
        name={name}
        label={label}
        initialValue={defaultValue}
        style={style}
      >
        <Select
          value={value}
          onChange={(type) => {
            onChange(type);
          }}
          disabled={disabled}
        >
          {Object.values(SubscriptionCycle).map((cycle) => (
            <Select.Option key={cycle} value={cycle}>
              {cycle}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    );
  }

  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={defaultValue}
      style={style}
    >
      <Select disabled={disabled}>
        {Object.values(SubscriptionCycle).map((cycle) => (
          <Select.Option key={cycle} value={cycle}>
            {cycle}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default SubscriptionCycleSelector;
